module.exports = __webpack_public_path__ + "img/arrow.49387ded.svg";